import { Link } from "react-router";
import type { BuyersGuide, StockedArticleProduct } from "../../../../shared/articleProducts";

export function ArticleStockedProducts({ products }: { products: StockedArticleProduct[] }) {
  return <section aria-labelledby="article-stocked-products" className="my-10 rounded-2xl border border-slate-200 bg-slate-50 p-6">
    <h2 id="article-stocked-products" className="text-xl font-bold text-slate-900">Products in stock</h2>
    {products.length ? <ul className="mt-4 divide-y divide-slate-200">{products.map(product => <li key={product.id} className="py-4 first:pt-0">
      <Link to={`/products/${product.id}`} className="font-semibold text-[#0d7078] underline">{product.name}</Link>
      {product.packageSize && <p className="mt-1 text-sm text-slate-600">Package: {product.packageSize}</p>}
      <p className="mt-1 text-sm text-slate-600">NDC: {product.ndc}</p>
      <span className="mt-2 inline-block rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-800">In stock</span>
    </li>)}</ul> : <p className="mt-3 text-slate-600">Please <Link to="/contact" className="font-semibold text-[#0d7078] underline">ask us about availability</Link>.</p>}
  </section>;
}

export function BuyersGuides({ guides }: { guides: BuyersGuide[] }) {
  if (!guides.length) return null;
  return <aside aria-label="Buyer's guides" className="my-6 rounded-xl border border-slate-200 bg-slate-50 p-5">
    <h2 className="font-bold text-primary">Buyer&apos;s guide</h2>
    <ul className="mt-3 space-y-3">{guides.slice(0, 2).map(guide => <li key={guide.slug}>
      <Link className="font-semibold text-accent underline" to={`/insights/${guide.slug}`}>{guide.title}</Link>
    </li>)}</ul>
  </aside>;
}
